import type { IntervalName } from 'shared/definitions/musicTheory/intervals';
import { Temperament } from './temperament';

// Frequency calculations:
const justFrequencies: {
  interval: IntervalName;
  frequencyMultiplier: number;
  halfStepsFromBase: number;
}[] = [
  {
    interval: 'P1',
    frequencyMultiplier: 1,
    halfStepsFromBase: 0,
  },
  // As the M3 from the M6
  {
    interval: 'A1',
    frequencyMultiplier: (5 / 3 / 2) * (6 / 5),
    halfStepsFromBase: 1,
  },
  {
    interval: 'M2',
    frequencyMultiplier: 9 / 8,
    halfStepsFromBase: 2,
  },
  {
    interval: 'm3',
    frequencyMultiplier: 6 / 5,
    halfStepsFromBase: 3,
  },
  {
    interval: 'M3',
    frequencyMultiplier: 5 / 4,
    halfStepsFromBase: 4,
  },
  {
    interval: 'P4',
    frequencyMultiplier: 4 / 3,
    halfStepsFromBase: 5,
  },
  // Here we take this as the M3 from the M2
  {
    interval: 'A4',
    frequencyMultiplier: (9 / 8) * (5 / 4),
    halfStepsFromBase: 6,
  },
  {
    interval: 'P5',
    frequencyMultiplier: 3 / 2,
    halfStepsFromBase: 7,
  },
  {
    interval: 'm6',
    frequencyMultiplier: 8 / 5,
    halfStepsFromBase: 8,
  },
  {
    interval: 'M6',
    frequencyMultiplier: 5 / 3,
    halfStepsFromBase: 9,
  },
  {
    interval: 'm7',
    frequencyMultiplier: 9 / 5,
    halfStepsFromBase: 10,
  },
  {
    interval: 'M7',
    frequencyMultiplier: 15 / 8,
    halfStepsFromBase: 11,
  },
];

export class JustTemperament extends Temperament {
  // eslint-disable-next-line class-methods-use-this
  getFrequency(midi: number) {
    console.log(`Just get frequency`);
    // If it's not an integer, throw!
    if (Math.round(midi) !== midi) {
      throw Error(`MIDI must be an integer, not ${midi}`);
    }

    const difference = midi - this.temperamentBase.getMidiNumber();
    let simpleInterval = difference % 12;
    let octaves = ~~(difference / 12);
    // If the difference is negative, make the simple interval positive,
    // and subtract an octave:
    if (simpleInterval < 0) {
      simpleInterval += 12;
      octaves--;
    }

    console.log(
      `difference: ${difference}, simpleInterval: ${simpleInterval}, Octaves: ${octaves}`
    );

    const justRatio = justFrequencies.find((f) => f.halfStepsFromBase === simpleInterval);

    if (!justRatio) {
      // This should never happen
      throw Error(`Not just interval found for half steps ${simpleInterval}`);
    }

    return this.temperamentBaseFrequency * justRatio.frequencyMultiplier * 2 ** octaves;
  }
}
